import { useState, useEffect } from "react";
import axios from "axios";
import MainLayout from "../layouts/MainLayout";
import AddManager from "./AddManager";
import EditManager from "./EditManager";

function Managers() {

const [managers,setManagers]=useState([]);
const [search,setSearch]=useState("");
const [showAddDialog,setShowAddDialog]=useState(false);

const [showEditDialog,setShowEditDialog]=useState(false);
const [selectedManager,setSelectedManager]=useState(null);

useEffect(()=>{

loadManagers();

},[]);

const loadManagers=async()=>{

try{

const token=localStorage.getItem("token");

const response=await axios.get(

"https://saleupcall.com/api/Manager/get-managers.php",

{
headers:{
Authorization:`Bearer ${token}`
}
}

);

if(response.data.status){

setManagers(
response.data.data
);

}

}
catch(error){

console.log(error);

}

};

const filteredManagers=

managers.filter(

(manager)=>

(manager.username || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(manager.employee_code || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(manager.mobile || "")
.includes(search)

||

(manager.designation_name || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(manager.department_name || "")
.toLowerCase()
.includes(search.toLowerCase())

);

const deleteManager=async(id)=>{

if(
!window.confirm(
"Delete this manager?"
)
){
return;
}

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.post(

"https://saleupcall.com/api/Manager/delete-manager.php",

{
id:id
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Deleted"
);

loadManagers();

}

}
catch(error){

console.log(error);

}

};

return(

<MainLayout>

<div className="container mt-1">

<div className="row mb-2">

<div className="col-md-4">

<h4>Managers</h4>

</div>

<div className="col-md-6">

<input
type="text"
className="form-control form-control-sm"
placeholder="Search Manager"
value={search}
onChange={(e)=>
setSearch(e.target.value)
}
/>

</div>

<div className="col-md-2">

<button
className="btn btn-success btn-sm w-100"
onClick={()=>
setShowAddDialog(true)
}
>

<i className="bi bi-plus-lg me-1"></i>

Add

</button>

</div>

</div>

<div className="table-responsive">

<table className="table table-bordered table-hover table-striped table-sm">

<thead className="table-success">

<tr>

<th>ID</th>
<th>Employee Code</th>
<th>Mobile</th>
<th>Department</th>
<th>Designation</th>
<th>Username</th>
<th>Email</th>
<th width="150">Actions</th>

</tr>

</thead>

<tbody>

{

filteredManagers.map(

(manager)=>(

<tr key={manager.id}>

<td>{manager.id}</td>

<td>{manager.employee_code}</td>

<td>{manager.mobile}</td>

<td>{manager.department_name}</td>

<td>{manager.designation_name}</td>

<td>{manager.username}</td>

<td>{manager.email}</td>

<td>

<button
className="btn btn-primary btn-sm me-1"
title="Edit"
onClick={()=>{

setSelectedManager(manager);

setShowEditDialog(true);

}}
>

<i className="bi bi-pencil"></i>

</button>

<button
className="btn btn-danger btn-sm me-1"
onClick={()=>
deleteManager(manager.id)
}
>

<i className="bi bi-trash"></i>

</button>

<button
className="btn btn-info btn-sm"
title="View"
>

<i className="bi bi-eye"></i>

</button>

</td>

</tr>

)

)

}

</tbody>

</table>

</div>

</div>

{
showAddDialog && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-lg">

<div className="modal-content">

<div className="modal-header">

<h5 className="modal-title">
Add Manager
</h5>

<button
type="button"
className="btn-close"
onClick={()=>
setShowAddDialog(false)
}
></button>

</div>

<div className="modal-body">

<AddManager
onClose={()=>{

setShowAddDialog(false);

loadManagers();

}}
/>

</div>

</div>

</div>

</div>

)

}

{
showEditDialog &&
selectedManager && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-lg">

<div className="modal-content">

<div className="modal-header">

<h5 className="modal-title">
Edit Manager
</h5>

<button
type="button"
className="btn-close"
onClick={()=>{

setShowEditDialog(false);

setSelectedManager(null);

}}
>

</button>

</div>

<div className="modal-body">

<EditManager
manager={selectedManager}
onClose={()=>{

setShowEditDialog(false);

setSelectedManager(null);

loadManagers();

}}
/>

</div>

</div>

</div>

</div>

)

}

</MainLayout>

);

}

export default Managers;